
// 套件
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
// 頁面
import { createBrowserHistory } from 'history';
import { WithoutNavbar, WithNavbar, WithSidebar } from './Components/NavbarControl';
import NotFound from 'Components/NotFound';

import Home from './Components/Home';
import Chat from "./Components/Hub/Chat";
import Login from './Authentication/Login'
import Lobby from './Components/Lobby/Lobby'
import './App.scss';
import './Components/Lobby/layout.css'
import AnalyzeList from './Components/Lobby/DashBoard/DetailTestAnalyze/Components/AnalyzeList';
import TestList from './Components/Lobby/DashBoard/DetailTestAnalyze/Components/TestList';

const Register = lazy(() => import('./Authentication/Register'))
const BridgeAnalysis = lazy(() => import('./Components/Lobby/Other/HighRisk'))
const CarBridge = lazy(() => import('./Components/Lobby/DashBoard/CarBridge'))
const ManBridge = lazy(() => import('./Components/Lobby/DashBoard/ManBridge'))
const Underpass = lazy(() => import('./Components/Lobby/DashBoard/Underpass'))
const DetailTestAnalyze = lazy(() => import('./Components/Lobby/DashBoard/DetailTestAnalyze'))
const BridgeSearch = lazy(() => import('./Components/Lobby/WorkInformation/BridgeSearch'))
const UnderpassSearch = lazy(() => import('./Components/Lobby/WorkInformation/UnderpassSearch'))
const BridgeTest = lazy(() => import('./Components/Lobby/WorkInformation/BridgeTest'))
const FileSearch = lazy(() => import('./Components/Lobby/Other/FileManagement'))
const FacilitiesManagement = lazy(() => import('./Components/Lobby/Other/FacilitiesManagement'))
const DataTransfer = lazy(()=>import('./Components/Lobby/WorkInformation/DataTransfer'))
const WaterLevel = lazy(() => import('./Components/Lobby/WorkInformation/WaterLevel'))
const MapSystem = lazy(() =>import('./Components/Lobby/Other/MapSystem/MapContainer'))
const RepairAndConstruction = lazy(() => import('./Components/Lobby/WorkInformation/RepairAndConstruction'))
const SystemManage = lazy(()=>import('./Components/Lobby/Other/SystemManagement'))
const DisasterPrevention = lazy(()=>import('./Components/Lobby/DashBoard/DisasterPrevention'))
const FootBridgeSearch = lazy(()=>import('./Components/Lobby/WorkInformation/FootBridgeSearch'))
const LightManage = lazy(()=>import('./Components/Lobby/Other/LightManagement'))

function App() {
  return (
    <Router>
      <div className="App">
        <div className="mainDiv">
          <Suspense fallback={<div>loading...</div>}>
            <Routes>
              <Route element={<WithoutNavbar />}>
                <Route path={process.env.PUBLIC_URL + "/Login"} element={<Login />} />
              </Route>
              <Route element={<WithNavbar />}>
                <Route path={process.env.PUBLIC_URL + "/"} element={<Home />} />
                <Route path="*" element={<NotFound />} />
                <Route path={process.env.PUBLIC_URL + "/Register"} element={<Register />} />
                <Route path={process.env.PUBLIC_URL + "/Lobby"} element={<Lobby />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/CarBridge"} element={<CarBridge />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/ManBridge"} element={<ManBridge />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/Underpass"} element={<Underpass />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/DetailTestAnalyze"} element={<DetailTestAnalyze />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/DetailTestAnalyze/AnalyzeList"} element={<AnalyzeList />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/DetailTestAnalyze/TestList"} element={<TestList />} />
                <Route path={process.env.PUBLIC_URL + "/Hub"} element={<Chat />} />
                
              </Route>
              <Route element={<WithSidebar />}>
                <Route path={process.env.PUBLIC_URL + "/Workinformation/BridgeSearch"} element={<BridgeSearch />} />
                <Route path={process.env.PUBLIC_URL + "/Workinformation/FootBridgeSearch"} element={<FootBridgeSearch />} />
                <Route path={process.env.PUBLIC_URL + "/Workinformation/UnderpassSearch"} element={<UnderpassSearch />} />
                <Route path={process.env.PUBLIC_URL + "/Other/Analysis"} element={<BridgeAnalysis />} />
                <Route path={process.env.PUBLIC_URL + "/Other/FacilitiesManagement"} element={<FacilitiesManagement />} />
                <Route path={process.env.PUBLIC_URL + "/Other/FileSearch"} element={<FileSearch />} />
                <Route path={process.env.PUBLIC_URL + "/Workinformation/BridgeTest"} element={<BridgeTest />} />
                <Route path={process.env.PUBLIC_URL + "/Workinformation/DataTransfer"} element={<DataTransfer />} />
                <Route path={process.env.PUBLIC_URL + "/Workinformation/WaterLevel"} element={<WaterLevel />} />
                <Route path={process.env.PUBLIC_URL + "/Other/MapSystem"} element={<MapSystem/>}/>
                <Route path={process.env.PUBLIC_URL + "/Workinformation/RepairAndConstruction"} element={<RepairAndConstruction />} />
                <Route path={process.env.PUBLIC_URL + "/Other/SystemManage"} element={<SystemManage />} />
                <Route path={process.env.PUBLIC_URL + "/Dashboard/DisasterPrevention/:status"} element={<DisasterPrevention/>} />
                <Route path={process.env.PUBLIC_URL + "/Other/LightManage"} element={<LightManage />} />
              </Route>
            </Routes>
          </Suspense>
        </div>
      </div>
    </Router>
  )
}

export default App;

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});
